"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var ContrastDialogContent_1 = __importDefault(require("./ContrastDialogContent"));
var ContrastDialogTitle_1 = __importDefault(require("./ContrastDialogTitle"));
var ContrastDialogActions_1 = __importDefault(require("./ContrastDialogActions"));
var Typography_1 = __importDefault(require("../Typography/Typography"));
var SplitDialog_css_1 = __importDefault(require("./SplitDialog-css"));
var FullPageSpinner_1 = __importDefault(require("../FullPageSpinner/FullPageSpinner"));
var SplitDialog = function (props) {
    var _a = react_1.default.useState(false), showHelp = _a[0], setShowHelp = _a[1];
    var titleRender = (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "space-between" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "h5" },
                props.title,
                props.dialogHelp && (react_1.default.createElement(InfoOutlined_1.default, { style: { cursor: "pointer", margin: "0px 0px -4px 4px" }, onClick: function () { return setShowHelp(!showHelp); } })))),
        props.showToggle && (react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(core_1.Switch, { checked: props.toggleValue, onChange: props.changeToggle, color: "primary" }))),
        props.subTitle && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(Typography_1.default, null, props.subTitle))),
        props.dialogHelp && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(core_1.Collapse, { in: showHelp }, props.dialogHelp)))));
    var titleComponent = (react_1.default.createElement(core_1.DialogTitle, { disableTypography: true, style: props.subTitle
            ? SplitDialog_css_1.default["invosys-ui-SplitDialog-title-with-subtitle"]
            : {} }, titleRender));
    var actionComponent = (react_1.default.createElement(core_1.DialogActions, null,
        props.otherActions,
        react_1.default.createElement("div", { style: { flexGrow: 1 } }),
        props.actions));
    if (!props.dialogContent || (props.direction || "").indexOf("reverse") > -1) {
        titleComponent = (react_1.default.createElement(ContrastDialogTitle_1.default, { disableTypography: true, style: props.subTitle
                ? SplitDialog_css_1.default["invosys-ui-SplitDialog-title-with-subtitle"]
                : {} }, titleRender));
    }
    if (props.contrastDialogContent &&
        ["row-reverse", "column"].includes(props.direction || "column")) {
        actionComponent = (react_1.default.createElement(ContrastDialogActions_1.default, null,
            props.otherActions,
            react_1.default.createElement("div", { style: { flexGrow: 1 } }),
            props.actions));
    }
    var dialogReturn = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: SplitDialog_css_1.default["invosys-ui-SplitDialog-container-flex-" + (props.direction || "column")] },
            props.dialogContent && (react_1.default.createElement(core_1.Paper, { elevation: 0, square: true, style: __assign(__assign({ flexBasis: props.displayProportions
                        ? props.displayProportions[0]
                        : "50%" }, ((props.direction || "column").indexOf("row") > -1
                    ? {}
                    : { msFlexPreferredSize: "auto" })), SplitDialog_css_1.default["invosys-ui-SplitDialog-content-wrapper"]) },
                react_1.default.createElement(core_1.DialogContent, { className: (props.contentClassName || "") + " invosys-ui-SplitDialog-content" }, props.dialogContent))),
            props.contrastDialogContent && (react_1.default.createElement(ContrastDialogContent_1.default, { className: (props.contrastContentClassName || "") + " \n              invosys-ui-SplitDialog-contrast-content", containerStyle: __assign(__assign({ flexBasis: props.displayProportions &&
                        props.displayProportions.length === 2
                        ? props.displayProportions[1]
                        : "50%" }, ((props.direction || "column").indexOf("row") > -1
                    ? {}
                    : { msFlexPreferredSize: "auto" })), SplitDialog_css_1.default["invosys-ui-SplitDialog-contrast-content-wrapper"]) }, props.contrastDialogContent))),
        props.actions && actionComponent));
    var open = props.open, title = props.title, direction = props.direction, actions = props.actions, otherActions = props.otherActions, dialogContent = props.dialogContent, contrastDialogContent = props.contrastDialogContent, fullWidth = props.fullWidth, maxWidth = props.maxWidth, className = props.className, contentClassName = props.contentClassName, contrastContentClassName = props.contrastContentClassName, subTitle = props.subTitle, dialogLoading = props.dialogLoading, displayProportions = props.displayProportions, toggleValue = props.toggleValue, showToggle = props.showToggle, changeToggle = props.changeToggle, dialogHelp = props.dialogHelp, otherProps = __rest(props, ["open", "title", "direction", "actions", "otherActions", "dialogContent", "contrastDialogContent", "fullWidth", "maxWidth", "className", "contentClassName", "contrastContentClassName", "subTitle", "dialogLoading", "displayProportions", "toggleValue", "showToggle", "changeToggle", "dialogHelp"]);
    return (react_1.default.createElement(core_1.Dialog, __assign({ open: Object.keys(props).includes("open") ? props.open : true, className: SplitDialog_css_1.default["invosys-ui-SplitDialog"] + " " + props.className, fullWidth: props.fullWidth, maxWidth: props.maxWidth, disableEnforceFocus: true }, otherProps),
        react_1.default.createElement(FullPageSpinner_1.default, { loading: props.dialogLoading }),
        props.title && titleComponent,
        dialogReturn));
};
SplitDialog.propTypes = {
    open: prop_types_1.default.bool,
    title: prop_types_1.default.string,
    direction: prop_types_1.default.oneOf([
        "row",
        "column",
        "row-reverse",
        "column-reverse"
    ]),
    actions: prop_types_1.default.array,
    otherActions: prop_types_1.default.array,
    dialogContent: prop_types_1.default.node,
    contrastDialogContent: prop_types_1.default.node,
    fullWidth: prop_types_1.default.bool,
    maxWidth: prop_types_1.default.oneOf(["lg", "md", "sm", "xl", "xs", false]),
    className: prop_types_1.default.string,
    contentClassName: prop_types_1.default.string,
    contrastContentClassName: prop_types_1.default.string,
    subTitle: prop_types_1.default.string,
    dialogLoading: prop_types_1.default.bool,
    displayProportions: prop_types_1.default.array,
    toggleValue: prop_types_1.default.bool,
    showToggle: prop_types_1.default.bool,
    changeToggle: prop_types_1.default.func,
    dialogHelp: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node])
};
exports.default = SplitDialog;
